import { render, staticRenderFns } from "./ProjectDeleteDialog.vue?vue&type=template&id=c3055f8c"
import script from "./ProjectDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports